import { SignupService } from './../../../shared/services/signup/signup.service';
import { VariablesService } from './../../../shared/services/variables/variables.service';
import { UtilService } from './../../../shared/services/util/util.service';
import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  CommonTalktousModalComponent
} from '../../../common/common-talktous-modal/components/common-talktous-modal/common-talktous-modal.component';
import { EventsService } from '../../../shared/services';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sip-nudge',
  templateUrl: './sip-nudge.component.html',
  styleUrls: ['./sip-nudge.component.scss']
})
export class SipNudgeComponent implements OnInit {
  isLoggedIn = false;
  @Input() user;
  constructor(
    private dialog: MatDialog,
    private util: UtilService,
    public events: EventsService,
    private vars: VariablesService,
    private signupService: SignupService
  ) { }

  ngOnInit() {
    this.util.isLoggedIn.subscribe(login => {
      this.isLoggedIn = login;
    });
  }
  // talk to us module
  openDialogTalkToUs() {
    this.dialog.open(CommonTalktousModalComponent, {
      maxWidth: '100vw',
      width: '519px',
      maxHeight: this.util.isMobile() ? '100vh' : 'auto',
      panelClass: 'talk-to-us-modal'
    });
  }
  // check for login
  checkForLogin(template) {
    if (this.isLoggedIn) {
      this.redirectToDonations();
    } else {
      this.signupService.openSignUp(template, 'si', () => {
        this.redirectToDonations();
      });
    }
  }
  private redirectToDonations() {
    const redirectUrl = encodeURIComponent(window.location.href);
    const url = `${environment.sipretention_domain}/mydonations?redirect_url=${redirectUrl}`;
    this.util.nativeNavigation(url);
  }

  // tracking
  trackButton() {
    this.events.sendSystemEvent(
      {
        eventName: 'give_monthly_new',
        page_name: this.vars.pageName,
        info_1: 'position',
        info_2: 'bottom_card',
        info_3: 'impact'
      }).subscribe(_ => _);
    this.util.redirectWithUTM('new/sip', { utm_term: 'browse', utm_content: 'bottom_card' });
    this.util.scrollToTop();
  }

}
